import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import {
  useGetAllAdminRolesMutation,
  useUpdateAdminRoleByIdMutation,
} from "../../../features/admin/adminRoles/adminRolesApi";
import { useGetAllAdminPanelPermissionsMutation } from "../../../features/admin/permissions/allPermissionsApi";

const EditAdminRolePermission = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedRole, setSelectedRole] = useState(location.state || {});
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const [getAllAdminPanelPermissions, { data: permissionsData }] =
    useGetAllAdminPanelPermissionsMutation();
  const [getAllAdminRoles, { data: rolesData }] = useGetAllAdminRolesMutation();
  const [updateAdminRoleById, { data: updateData, error: updateError }] =
    useUpdateAdminRoleByIdMutation();

  useEffect(() => {
    const token = sessionStorage.getItem("access_token");
    getAllAdminPanelPermissions({ token });
    getAllAdminRoles({ token });
  }, []);

  useEffect(() => {
    if (rolesData?.body?.length && selectedRole?.id) {
      const currentRole = rolesData.body.find((role) => role.id === selectedRole.id);
      if (currentRole) {
        setSelectedRole(currentRole);
        setSelectedOptions(currentRole.permission || []);
      }
    }
  }, [rolesData, selectedRole?.id]);

  useEffect(() => {
    if (!permissionsData?.body?.length) return;

    const grouped = permissionsData.body.map((parent) => ({
      category: parent.name,
      id: parent.id,
      label: parent.action,
      children: (parent.children || []).map((child) => ({
        category: child.name,
        id: child.id,
        label: child.action,
      })),
    }));

    setOptions(grouped);
  }, [permissionsData]);

  useEffect(() => {
    if (updateData) {
      toast.success("Permissions updated successfully");
      navigate("/adminRoles");
    }
    if (updateError) toast.error("Failed to update permissions");
  }, [updateData, updateError]);

  const toggleOption = (optionId, children = []) => {
    setSelectedOptions((prev) => {
      if (prev.includes(optionId)) {
        const childIds = children.map((child) => child.id);
        return prev.filter((id) => id !== optionId && !childIds.includes(id));
      }
      return [...prev, optionId];
    });
  };

  const toggleChild = (childId, parentId) => {
    setSelectedOptions((prev) => {
      if (prev.includes(childId)) {
        return prev.filter((id) => id !== childId);
      }
      return prev.includes(parentId) ? [...prev, childId] : [...prev, parentId, childId];
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    updateAdminRoleById({
      token: sessionStorage.getItem("access_token"),
      id: selectedRole.id,
      data: { permission: selectedOptions },
    });
  };

  return (
    <div className="page-content container-fluid">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="mb-0">Edit Permissions - {selectedRole?.name}</h4>
        <button className="btn btn-secondary btn-sm" onClick={() => navigate("/adminRoles")}>
          Back
        </button>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="card">
          <div className="card-body">
            {options.map((option) => (
              <div key={option.id} className="mb-4">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedOptions.includes(option.id)}
                    onChange={() => toggleOption(option.id, option.children)}
                    id={`parent-${option.id}`}
                  />
                  <label className="form-check-label font-weight-bold" htmlFor={`parent-${option.id}`}>
                    {option.category}
                  </label>
                </div>
                <div className="ml-4 mt-2">
                  {option.children.map((child) => (
                    <div key={child.id} className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={selectedOptions.includes(child.id)}
                        onChange={() => toggleChild(child.id, option.id)}
                        id={`child-${child.id}`}
                      />
                      <label className="form-check-label" htmlFor={`child-${child.id}`}>
                        {child.category}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className="card-footer text-right">
            <button type="submit" className="btn btn-primary">
              Save Permissions
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default EditAdminRolePermission;
